/** Generic toasts. Feature-specific toasts live in features/*. */
const dictionary = {
  "en": {
    "genericError": "Something went wrong. Please try again.",
    "success": "Success",
    "emailCopied": "Email Copied to clipboard!",
    "emailsCopied": "Emails Copied to clipboard!",
    "inviteUrlCopied": "Invite URL copied to clipboard",
    "sending": "Sending...",
    "mailSent": "A confirmation mail has been sent successfully.",
    "successMessage": "Success Message"
  },
  "de": {
    "genericError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "success": "Erfolg",
    "emailCopied": "E-Mail in die Zwischenablage kopiert!",
    "emailsCopied": "E-Mails in die Zwischenablage kopiert!",
    "inviteUrlCopied": "Einladungs-URL in die Zwischenablage kopiert",
    "sending": "Wird gesendet...",
    "mailSent": "Eine Bestätigungsmail wurde erfolgreich gesendet.",
    "successMessage": "Erfolgsmeldung"
  },
  "fi": {
    "genericError": "Jokin meni pieleen. Yritä uudelleen.",
    "success": "Onnistui",
    "emailCopied": "Sähköpostiosoite kopioitu leikepöydälle!",
    "emailsCopied": "Sähköpostiosoitteet kopioitu leikepöydälle!",
    "inviteUrlCopied": "Kutsulinkki kopioitu leikepöydälle",
    "sending": "Lähetetään...",
    "mailSent": "Vahvistusviesti on lähetetty.",
    "successMessage": "Onnistumisviesti"
  }
};

export default dictionary;
